import axiosInstance from "./axiosInstance";


export const sendLoginOtp = (mobileNumber) => {
  return axiosInstance.post("/api/user/auth/login-send-otp", {
    mobileNumber,
  });
};

export const verifyLoginOtp = (mobileNumber, otp) => {
  return axiosInstance.post("/api/user/auth/login-verify-otp", {
    mobileNumber,
    otp,
  });
};


export const logoutApi = async () => {
  const res = await axiosInstance.post("/api/user/auth/user-logout");
  return res.data;
};



export const getNewAcessTokenApi = async()=>{
  const res = await axiosInstance.post("/api/user/auth/get/new-acess-token");
  return res.data;
}



export const checkAuthApi = async()=>{
  const res = await axiosInstance.get("/api/user/check-auth-me");
  return res.data;
}


export const createBookingApi = async (payload) => {
  const res = await axiosInstance.post(
    "/api/user/auth/create-booking",
    payload
  );
  return res.data;
};



export const getBookingHistory = async ()=>{
  const res = await axiosInstance.get("/api/user/auth/find-booking-history");
  return res.data;
}








export const createPrePaidOrderApi = async (amount) => {
  const res = await axiosInstance.post( "/api/user/prepaid/order",
    { amount }  
  );
  return res;
};



export const checkOutPrePaidBooking = async(data)=>{
  const res = await  axiosInstance.post("/api/user/prepaid/booking",  data  );
  return res;

}